import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'

import { ApiKeyModal } from '#/features/api-key-modal/api-key-modal'
import { NextPageWithLayout } from '#/pages/_app'
import { getDeviceType } from '#/shared/lib/helpers'

import { useApiKeysPage } from '../model/use-api-keys'

import { ApiKeysDesktop } from './api-keys-desktop'
import { ApiKeysMobile } from './api-keys-mobile'

const ApiKeysPage: NextPageWithLayout = () => {
	const state = useApiKeysPage()
	const [device, setDevice] = useState<'desktop' | 'mobile'>('desktop')

	useEffect(() => {
		if (typeof window === 'undefined') {
			return
		}
		setDevice(getDeviceType())
	}, [])

	const ContentComponent = device === 'mobile' ? ApiKeysMobile : ApiKeysDesktop

	return (
		<>
			<ApiKeyModal open={state.modalOpen} setOpen={state.setModalOpen} keys={state.keys} setKeys={state.setKeys} />
			<Box sx={{ marginTop: '20px', marginBottom: '20px' }}>
				<Typography sx={{ fontSize: 35, fontWeight: '600' }}>API ключи</Typography>
			</Box>
			<ContentComponent state={state} />
		</>
	)
}

export default ApiKeysPage

